export const ETHANOL = 0.789;



// WEBPACK FOOTER //
// ./src/constants.js